import { backendFetch } from '../apiUtils';

/**
 * V2 business partner status (QA Financials / Customs MoP with Representative).
 * Endpoint: v2/businesspartner/bpStatus
 */
export const getBusinessPartnerStatus = async (id, parentId) => {
  const params = { id };
  if (parentId) {
    params.parentId = parentId;
  }

  const response = await backendFetch({
    url: 'v2/businesspartner/bpStatus',
    method: 'GET',
    params,
  });

  // V2 responses are typically wrapped in { data }; fall back if unwrapped.
  return response?.data ?? response;
};

export const getPoNumberFromJiraTicket = async (jiraTicket) => {
  /** returns a PO Number for freshways - based on the Jira Ticket number provided */
  const response = await backendFetch({
    url: 'v2/businessPartner/freshwaysPo',
    params: { jiraTicket },
    method: 'GET',
  });

  return response.data;
};

export const getBusinessPartnerParent = async (id) => {
  const response = await backendFetch({
    url: 'v2/businesspartner/parentById',
    method: 'GET',
    params: { id },
  });

  return response?.data ?? response;
};

export const postVATRestrictions = async (data) => {
  const response = await backendFetch({
    url: 'v2/businesspartner/vatRestrictions',
    method: 'POST',
    options: {
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json' },
    },
  });

  return response?.data ?? response;
};
